import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const LoginFn = (reqbody) => {
    const response = protectedApi.post(`${ENDPOINTS.login_api}`, reqbody);
    return response;
}

